<template>
  <v-container fill-height="fill-height" style="opacity: .91">
        <v-layout align-center="align-center" justify-center="justify-center">
                <v-fade-transition mode="out-in">

          <v-flex class="login-form text-xs-center"> 
            <div class="display-1 mb-3 black--text">
              <v-img
              src="../assets/Asset-11@3x-1-1024x218.png"
              height="125"
              contain
              aspect-ratio="1"
            ></v-img>Welcome to Snatch
            </div>
            <v-card light="light">
              <v-card-text>
                <div class="subheading">
                  <template>Reset Password</template>
                </div>
                <v-form ref="loginForm" action="#" @submit.prevent="validateBeforeSubmit" lazy-validation>
                  <v-text-field readonly required :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Please enter an email address']" v-model="user.name" light="light" prepend-icon="fa fa-user" label="Email" type="text"></v-text-field>
                  <v-text-field :append-icon="user.show ? 'mdi-eye' : 'mdi-eye-off'" :type="user.show ? 'text' : 'password'" @click:append="user.show = !user.show"
                   required :rules="[v => !!v || 'Password is required']" v-model="user.password" light="light" prepend-icon="fa fa-lock" label="Password"></v-text-field>
                  <v-text-field :append-icon="user.show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="user.show2 ? 'text' : 'password'" @click:append="user.show2 = !user.show2"
                   required :rules="[v => !!v || 'Password is required', v => confirmPword || 'Please ensure your password matches']" v-model="user.cpassword" light="light" prepend-icon="fa fa-lock" label="Confirm Password"></v-text-field>
                  <v-checkbox v-if="options.isLoggingIn" v-model="options.shouldStayLoggedIn" light="light" label="Stay logged in?" hide-details="hide-details"></v-checkbox>
                  <v-btn outlined color="#FFD100" style="background: black" block="block" type="submit" :loading="loading" :disabled="loading" class="mt-2">
                        Reset Password
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                  </v-btn>                 
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
                </v-fade-transition>
          <v-footer app="app">
      <v-flex class="caption">Copyright By SNATCH PARK BIZSOLUTIONS SDN BHD © 2021</v-flex>
    </v-footer>
        </v-layout>
        <v-dialog
        v-model="dialog"
        persistent
        width="300"
        >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Logging In...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
        </v-dialog>
        <v-snackbar
        v-model="toaster"
        :color="toasterColor"
        top
        >
        {{ toastertxt }}
        </v-snackbar>
      </v-container>
</template>

<script>
import timer from '../assets/js/sleeper';

export default {
    name: 'updateemail',

    data(){
        return {
            options: {
                isLoggingIn: '',
                shouldStayLoggedIn: true,
            },

            user: {
                name: '',
                password: '',
                cpassword: '',
                show: false,
                show2: false
            },

            loading: false,
            dialog: false,
            toaster: false,
            toastertxt: '',
            toasterColor: ''
        }
    },

    created(){
        //this.test1();
        this.verifyEmail();
    },

    computed: {
      confirmPword(){
        if (this.user.password !== this.user.cpassword){
            return false;
        }

        else{
            return true;
        }
     }
    },

    methods: {
        async resetPassword(){
            this.loading = true
            this.dialog = true

            try{
                let response = await this.$store.dispatch("createNameEmailPassword", {
                                    username: atob(this.$route.query.email),
                                    verifykey: this.$route.query.verifykey,
                                    password: this.user.password,
                                    confirmpassword: this.user.cpassword
                                    })

                await timer.sleep(100);
                if (response.data.code == 'AP000')
                {
                    this.loading = false;
                    this.dialog = false;
                    this.toaster = true;
                    this.toastertxt = "Password has been reset! Directing you to login page";
                    this.toasterColor = 'green'
                    await timer.sleep(800);
                    this.$router.push({ name: "login" });
                }

                else
                {
                    this.loading = false;
                    this.dialog = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong!";
                    this.toasterColor = 'red'
                }
            }

            catch(err){
                this.loading = false;
                this.dialog = false;
            }
        },

        async verifyEmail(){
            try{
                let response = await this.$store.dispatch("verifyNameEmail", {
                                    email: this.$route.query.email,
                                    verifykey: this.$route.query.verifykey
                                    })

                if (response.data.code == 'AP000')
                {
                    if (this.$route.query.email){
                        this.user.name = atob(this.$route.query.email);
                    }
                }

                else if (response.data.code === 'AP002')
                {
                    this.toaster = true;
                    this.toastertxt = "1 hour timer. The verification link has expired. Please contact support"
                    this.toasterColor = 'red';
                }

                else if (response.data.code === 'AP105')
                {
                    this.toaster = true;
                    this.toastertxt = "You email has been updated! Directing you to login page."
                    this.toasterColor = 'red';
                    await timer.sleep(800);
                    this.$router.push({ name: "login" });
                }

                else if (response.data.code === 'AP106')
                {
                    this.toaster = true;
                    this.toastertxt = "Link expired! Directing you to login page."
                    this.toasterColor = 'red';
                    await timer.sleep(800);
                    this.$router.push({ name: "login" });
                }

                else if (response.data.code === 'AP103')
                {
                    this.toaster = true;
                    this.toastertxt = "Sorry, we are unable to update the email as requested at the moment."
                    this.toasterColor = 'red';
                }

                else
                {
                    this.toaster = true;
                    this.toastertxt = "Something went wrong!"
                    this.toasterColor = 'red';
                }
            }

            catch(err){}
        },

        validateBeforeSubmit() {
            if (this.$refs.loginForm.validate()) {
                this.resetPassword();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.login-form{
    max-width: 500px !important;
}
</style>